import axios from "axios";
import {
  Bookmark,
  Column,
  ID,
  Label,
  StorageData,
  TaskData,
} from "@/types/task";
import { store } from "@/store/share/index";
import { defaultsBookmarks, State } from "@/store/share/state";
import Storage from "@/store/share/storage";
// import { store } from "@/store";
import { FILE_NAME, META, NOTIFICATION } from "@/types/constant";
import { File } from "@/types/drive";
import { MutationTypes } from "@/store/share/mutation-types";

export default class WebStorage {
  public state(version = 2): object {
    if (version === 1) {
      const data = {
        COLUMNS: [],
        CHECK_LIST: [],
        SETTINGS: {},
      };

      return data;
    } else if (version === 2) {
      const {
        googleToken,
        userInfo,
        settings,
        bookmarks,
        columns,
        labels,
        checkList,
      } = store.state;

      const data = {
        meta: META,
        googleToken,
        userInfo,
        settings,
        bookmarks,
        columns,
        labels,
        checkList,
      };

      return data;
    }

    return {};
  }

  get(): State | null {
    try {
      const value = localStorage.getItem("data") || "";
      return JSON.parse(value);
    } catch (e) {
      return null;
    }
  }

  public async getFromDrive(): Promise<void | null> {
    const token: string | null = store.state.googleToken;
    if (!token) return null;
    const state = await this.readDriveContent(token);
    return state;
  }

  public async mergeFromDrive(): Promise<void | null> {
    const token: string | null = store.state.googleToken;
    if (!token) return null;
    const state = await this.readDriveContent(token);
    return state;
  }

  public async set(data: object): Promise<void> {
    const strData = JSON.stringify(data);
    // Save on LocalStorage
    localStorage.setItem("data", strData);
    // Save on GoogleDrive
    return await this.fileData(strData);
  }

  public async setOnLocalStorage(data: object) {
    const strData = JSON.stringify(data);

    // Save on LocalStorage
    localStorage.setItem("data", strData);
  }

  remove(): void {
    // window[this.storageType].removeItem(this.key);
  }

  private blobFile(data: string) {
    const file = new Blob([data], {
      type: "text/plain",
    });
    const metadata = {
      name: FILE_NAME,
      mimeType: "text/plain",
    };

    // create form data for submit ==========
    const form = new FormData();
    form.append(
      "metadata",
      new Blob([JSON.stringify(metadata)], { type: "application/json" })
    );
    form.append("file", file);

    return form;
  }

  private async fileData(data: string): Promise<void> {
    const accessToken = store.state.googleToken;

    // When user doesnt have any google token
    if (!accessToken) return;
    // create file data ==================
    const form = this.blobFile(data);

    const savedFile: File | null = await this.getFileContent(accessToken);
    if (savedFile) {
      return await this.updateFile(savedFile.id, form);
    } else {
      return await this.createFile(form);
    }
  }

  private async updateFile(fileId: ID, form: any) {
    return axios
      .put(
        "https://www.googleapis.com/upload/drive/v2/files/" +
          fileId +
          "?uploadType=multipart&supportsAllDrives=true",
        form,
        {
          headers: { Authorization: "Bearer " + store.state.googleToken },
        }
      )
      .then((res) => {
        // return res.json();
      })
      .catch(({ response }) => {
        if (response.status == "401") {
          store.commit(MutationTypes.SET_NOTIFICATION, {
            text: NOTIFICATION.expiredToken,
            type: "error",
            name: "expiredToken",
            time: 5000,
          });
          store.commit(MutationTypes.LOGOUT);
          store.commit(MutationTypes.SET_LOADING, { isOpen: false });
        }
      });
  }

  private async createFile(form: any) {
    axios
      .post(
        "https://www.googleapis.com/upload/drive/v3/files?uploadType=multipart&supportsAllDrives=true",
        form,
        {
          headers: { Authorization: "Bearer " + store.state.googleToken },
        }
      )
      .then((res) => {
        // return res.json();
        return res.data;
      })
      .catch(({ response }) => {
        console.log("offline", response);
        if (response.status == "401") {
          store.commit(MutationTypes.SET_NOTIFICATION, {
            text: NOTIFICATION.expiredToken,
            type: "error",
            name: "expiredToken",
            time: 5000,
          });
        }

        if (response.status == "403") {
          store.commit(MutationTypes.SET_NOTIFICATION, {
            text: NOTIFICATION.accessDenied,
            type: "error",
            name: "accessDenied",
            time: 5000,
          });
        }

        store.commit(MutationTypes.LOGOUT, { isOpen: false });
        store.commit(MutationTypes.SET_LOADING, { isOpen: false });
      });
  }

  private async getFileContent(token: string | null): Promise<File | null> {
    if (store.state.googleFile) {
      return store.state.googleFile;
    }

    let driveContentFile = null;

    await axios
      .get("https://www.googleapis.com/drive/v3/files", {
        headers: {
          Authorization: "Bearer " + token,
        },
      })
      .then(async (res: any) => {
        driveContentFile = res.data?.files?.find(
          (file: any) =>
            file.name === FILE_NAME && file.mimeType === "text/plain"
        );
        if (driveContentFile) {
          store.commit(MutationTypes.SET_DRIVE_FILE, driveContentFile);
        } else {
          const strData = JSON.stringify(this.state());
          const form = this.blobFile(strData);
          await this.createFile(form);
          store.commit(MutationTypes.SET_LOADING, { isOpen: false });
        }
      })
      .catch(({ response }) => {
        console.log("offline", response);
        if (response.status == "401") {
          store.commit(MutationTypes.SET_NOTIFICATION, {
            text: NOTIFICATION.expiredToken,
            type: "error",
            name: "expiredToken",
            time: 5000,
          });
        }

        if (response.status == "403") {
          store.commit(MutationTypes.SET_NOTIFICATION, {
            text: NOTIFICATION.accessDenied,
            type: "error",
            name: "accessDenied",
            time: 5000,
          });
        }

        store.commit(MutationTypes.LOGOUT);
        store.commit(MutationTypes.SET_LOADING, { isOpen: false });
      });

    return driveContentFile;
  }

  private async readDriveContent(token: string): Promise<any | null> {
    const savedFile: File | null = await this.getFileContent(token);

    if (!savedFile) return null;

    let driveContentFile: any;
    await axios
      .get(
        "https://www.googleapis.com/drive/v3/files/" +
          savedFile?.id +
          "?alt=media",
        {
          headers: {
            Authorization: "Bearer " + token,
          },
        }
      )
      .then((res) => {
        //TODO: if (res.status == "401") {
        //   fetchGoogleToken();
        // }
        driveContentFile = res.data;
      })
      .catch(async ({ response }) => {
        console.log("offline", response);
        if (response.status == "401") {
          store.commit(MutationTypes.SET_NOTIFICATION, {
            text: NOTIFICATION.expiredToken,
            type: "error",
            name: "expiredToken",
            time: 5000,
          });
        }

        if (response.status == "403") {
          store.commit(MutationTypes.SET_NOTIFICATION, {
            text: NOTIFICATION.accessDenied,
            type: "error",
            name: "accessDenied",
            time: 5000,
          });
        }

        if (response.status == "404") {
          const strData = JSON.stringify(this.state());
          const form = this.blobFile(strData);
          await this.createFile(form);
          store.commit(MutationTypes.SET_LOADING, { isOpen: false });
          return;
        }

        store.commit(MutationTypes.LOGOUT);
        store.commit(MutationTypes.SET_LOADING, { isOpen: false });
      });

    return driveContentFile;
  }

  public async setImage(data: object): Promise<void> {
    const strData = JSON.stringify(data);
    // Save on LocalStorage
    localStorage.setItem("data", strData);
    // Save on GoogleDrive
    await this.fileData(strData);
  }

  public async createStateFile(data: object): Promise<void> {
    const blob = new Blob([JSON.stringify(data)], {
      type: "text/plain",
    });
    const elem = window.document.createElement("a");
    elem.href = window.URL.createObjectURL(blob);
    elem.download = FILE_NAME;
    document.body.appendChild(elem);
    elem.click();
    document.body.removeChild(elem);
  }
}
